// Full-document render of the sealy FinancePage: PageSkeleton (the React
// document shell) wrapping the existing consolidated finance-page body
// assembly. The legacy template rendered the body island in
// {% block layout %} -- adjacent to content inside <main>, so the document DOM
// matches the content-block pages. The six side-channel props (default plan
// terms, richtext-expanded headline, disclosure HTML, hero image URL) are
// threaded through unchanged from the server's get_finance_page_body data.
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { SealyFinancePageBody } from "../components/SealyFinancePageBody";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader/RichNavigation chain via PageSkeleton, which is typed
// with mutable reactivated props (see PageSkeleton). The body template accepts
// Immutable props, to which these are assignable.
export const Template = (
    props: templates.SealyFinancePageTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <SealyFinancePageBody
            page={props.page}
            apr={props.apr}
            term_months={props.term_months}
            fine_print_superscript={props.fine_print_superscript}
            headline_html={props.headline_html}
            terms_html={props.terms_html}
            hero_image_url={props.hero_image_url}
        />
    </PageSkeleton>
);
